var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPoup)?_c('div',{staticClass:"kefu-container",attrs:{"id":"kefu"}},[_c('div',{staticClass:"kefu-title",on:{"click":_vm.openPoup}},[_vm._v(_vm._s(_vm.$t('support')))]),_c('Popup',{ref:"popup"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }